import { useQuery } from '@tanstack/react-query';

import { useAuthStore } from 'src/entities/user/store/useAuthStore';

import { getProducts } from '../api/getProducts';
import {
  getProductLastUpdatedAt,
  sortByLastUpdated
} from '../utils/lastUpdated';

export const useProducts = () => {
  const selectedOrganization = useAuthStore(
    (state) => state.selectedOrganization
  );
  const query = useQuery({
    queryKey: ['products-all'],
    queryFn: async () => {
      const response = await getProducts();

      // Most recently updated first, matching the products table order.
      return sortByLastUpdated(response.data, getProductLastUpdatedAt);
    },
    enabled: !!selectedOrganization,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 0
  });

  return query;
};
